import { render, staticRenderFns } from "./object-table-expanded-row.vue?vue&type=template&id=213f1fdb&scoped=true&"
import script from "./object-table-expanded-row.vue?vue&type=script&lang=ts&"
export * from "./object-table-expanded-row.vue?vue&type=script&lang=ts&"
import style0 from "./object-table-expanded-row.vue?vue&type=style&index=0&id=213f1fdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f1fdb",
  null
  
)

export default component.exports